const orderStatuses = {
  0: 'Pagamento pendente',
  1: 'Pago',
  2: 'Cancelado',
  3: 'Reembolso pendente',
  4: 'Reembolsado',
  5: 'Usado como desconto',
  6: 'Pagamento recusado',
  7: 'Pagamento devolvido',
  8: 'Em análise',
  9: 'Revisão pendente',
}

export default orderStatuses
